import React from "react";
import "./CaseTabs.css";



const CaseTabs = ({ id, title, active, setSelected }) => {
  return (
    <li
      key={id}
      className={active ? "button active" : "button"}
      onClick={() => setSelected(id)}
    >
      {title} {/* Display the title */}
    </li>
  );
};

export default CaseTabs;